
export enum TriggerInspectionExpiredBlockNotificationsSaleType {
  Auction= 'Auction',
  DirectSale= 'DirectSale',

}